var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Input',{staticClass:"form-input",attrs:{"value":_vm.value,"maxlength":_vm.maxlength,"placeholder":_vm.placeholder,"size":"large"},on:{"input":_vm.handleInput,"on-focus":_vm.onFocus,"on-blur":_vm.onBlur,"on-enter":_vm.enterHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }